import { render, staticRenderFns } from "./productout.vue?vue&type=template&id=01538fdc&scoped=true"
import script from "./productout.vue?vue&type=script&lang=js"
export * from "./productout.vue?vue&type=script&lang=js"
import style0 from "./productout.vue?vue&type=style&index=0&id=01538fdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01538fdc",
  null
  
)

export default component.exports